module.exports = __webpack_public_path__ + "static/demo-screen-7-9e9f1ebea70193e89926bc1373cfe7a4.jpg";